import React, { useEffect } from "react";
import "../../views/dashboard/Dashboard.scss";
import {
  FiPlay,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../config/";

const PlaylistCard = ({props}) => {
  return (
    <div className="col">
      <div className="card h-100 shadow-sm ">
        <img
          style={{ height: "20rem", width: "25rem"}}
          src={`${BASE_URL}uploads/${props?.banner}`}
          className="card-img-top"
          alt="..."
        />
        <div className="card-body">
          <Link to={`/login`} className="play">
            <FiPlay />
          </Link>
          <h5 className="card-title h2 font-weight-bold ">
            {props?.title}
          </h5>
          <div className="h3 font-weight-bold text-success mt-2 mb-3">
            $ {props?.price}
          </div>
          <p className="card-text text-muted font-weight-light h5 ">
            {props?.description}
          </p>
        </div>
        {/* <div className="card-footer bg-white ">
          <div className="h5 font-weight-light footer-text">
            4 Lectures | {props.item.duration} hr | <Link to={props.item.created_by._id === props.profile._id ? `/profile/` : `/view-profile/${props.item.created_by._id}`}>{props.item.created_by.name}</Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PlaylistCard;